<div #main style="margin: 8px 4px 4px 4px;background-color: #333333; width: calc(100vw - 8px); height: calc(100vh - 72px); border-radius: var(--border-radius); display: flex; flex-direction: column; position:relative;" data-cy="tdo-imaging">
  <div style="flex-basis: 40px;" data-cy="tdo-imaging-top-menu-container">
    <app-imaging-top-menu #topMenu [openItems]="listOpenImages"
                          [selectedContainer]="selectedContainer"
                          [isShowBadge] = "isShowBadge"
                          (topMenuEvent)="onTopMenuEvent($event)" data-cy="tdo-imaging-top-menu">
    </app-imaging-top-menu>
  </div>
  <div style="flex: 1; padding-left: 10px; padding-bottom: 8px; padding-right: 10px;" data-cy="tdo-imaging-content">
    <tdo-mdi-manager *ngIf="isReady" style="max-height: 100%; margin-bottom: 20px;" #mdiManager (dblclick)="onMDIManagerDblClicked()" data-cy="tdo-imaging-mdi-manager">
      <tdo-mdi-item #mdiItem *ngFor="let im of listOpenImages" [parentContainer]="mdiManager.elRef.nativeElement"
                    (tdoMdiItemResized)="cnt.imageViewerSizeChanged()"
                    (headerDoubleClicked)="onImageDoubleClick($event)"
                    (tdoMdiItemSelected)="onImageContainerClicked(im, cnt)" data-cy="tdo-imaging-mdi-item-{{im.ImageID}}">
        <app-tdo-imaging-image-container #cnt (click)="onImageContainerClicked(im, cnt)" style="width: 100%; height: 100%;"
                                         [xImage]="im"
                                         [imageCategoryIds]="im.Categories"
                                         [isSelected]="im.selected"
                                         [fileName]="im.selectedFile"
                                         [ImageName]="im.ImageID"
                                         [annotationXmlData]="im.annotationXmlData"
                                         [blob]="im.blob"
                                         [toothDetailList]="toothDetail"
                                         [isMultipleCaseItem]="isMultipleCaseItem"
                                         (imageSaved)="onImageSaved($event)"
                                         (maximize)="mdiItem.toggleMaximize();"
                                         (editTags)="topMenu.openCategoriesMenu()"
                                         (originalImageLoaded)="onContainerOriginalImageLoaded($event, mdiItem)"
                                         (toothSelectorUpdate)="onToothSelectorUpdate()"
                                         (imageDoubleClicked)="onImageDoubleClick($event)"
                                         (continuousXray)="onContinuousXray($event)"
                                         (close)="onImageClose($event)" data-cy="tdo-imaging-image-container-{{im.ImageID}}">
        </app-tdo-imaging-image-container>
      </tdo-mdi-item>
    </tdo-mdi-manager>
  </div>
</div>
<app-imaging-tools-menu [parentContainer]="main"
                        (drawingToolEvent)="onDrawingToolEvent($event)"
                        (orientationToolEvent)="onOrientationToolEvent($event)"
                        (canvasToolEvent)="onCanvasToolEvent($event)"
                        (adjustmentToolEvent)="onAdjustmentToolEvent($event)"
                        (textToolEvent)="onTextToolEvent($event)"
                        (magnificationToolEvent)="onMagnificationToolEvent($event)"
                        (attributeEvent)="onAttributeEvent($event)"
                        (functionToolEvent)="onFunctionToolEvent($event)"
                        [brightnessVal]="selectedContainer?.xImage.brightnessVal"
                        [contrastVal]="selectedContainer?.xImage.contrastVal"
                        [gammaVal]="selectedContainer?.xImage.gammaVal"
                        [currentColorSelection]="selectedContainer?.xImage.annotationsDefaults.strokeColor"
                        [currentStrokeWidth]="selectedContainer?.xImage.annotationsDefaults.strokeWidth"
                        style="position:absolute; z-index: 5000; bottom: 8px; left: 10px;" data-cy="tdo-imaging-tools-menu">
</app-imaging-tools-menu>
